module.exports = __webpack_public_path__ + "63017dc6055968cf8cedd5b491c60070.svg";